import {until} from 'lit-html/directives/until';
import {products} from '@modules/i18n-labels';

export default(ctx, html) => html`
  <div class="product-wrapper d-inline-block text-center align-top px-1">
    <img src="${ctx.image()}" alt="${ctx.product}" class="w-100">
    <div class="text line-height-1 mt-2 h6">
      ${until(products[ctx.product])}
    </div>
  </div>
`;
